import { Extension } from '@tiptap/core';
import * as typingBuffer from '../utils/typingBufferSingleton';
import { defer } from 'lodash';

// Helper function outside the extension to handle the buffer processing logic
function processBuffer(editor: any): void {
    const chars = typingBuffer.consume();
    if (!chars) return;

    // Use defer to ensure the editor is fully ready
    defer(() => {
        try {
            editor.commands.insertContent(chars);
            editor.commands.focus('end');
        } catch (error) {
            console.error('Failed to insert typing buffer content:', error);
        }
    });
}

/**
 * Extension to put the typing buffer's content into the editor when it receives focus or is created.
 */
export const TypingBuffer = Extension.create({
    name: 'typingBuffer',

    onCreate(): void {
        processBuffer(this.editor);
    },

    onFocus(): void {
        // This means we consume the typing buffer twice, but that's fine -
        // the user may have typed more characters while the editor was initing.
        processBuffer(this.editor);
    },
});
